import _ from 'lodash'
import chartOptionUtil from '../utils/chartoption'

class ChartOptionService {
  getBasicChartOption (analyzeId) {
    let chartOption = chartOptionUtil.getBasicChartOption(analyzeId)
    return chartOption
  }

  buildIF0002ChartData (basicData, type, dataItems, ages) {
    let options = []
    let chartOption = _.cloneDeep(basicData)
    let isGender = _.startsWith(type, 'gender')
    let key = type
    let age = 10

    if (isGender) {
      key = _.replace(type, 'gender_', '')
      age = parseFloat(_.replace(type, 'gender_age_', ''))
    } else {
      age = parseFloat(_.replace(type, 'age_', ''))
    }
    let agesCategories = chartOptionUtil.getAgesFromDb(ages, age)
    let data = chartOptionUtil.getAgesData(agesCategories)
    let genderDatas = {
      '1': _.cloneDeep(data),
      '2': _.cloneDeep(data),
      'all': _.cloneDeep(data)
    }
    dataItems.forEach(item => {
      let ageKey = _.get(item, key)
      if (isGender) {
        // 条件：fixedgroupby = 'gender_age{age}' and gender={gender} and store_cd = '99999（女性の場合はwoman_total）'
        const curGender = chartOptionUtil.getGender(item.gender)
        if (curGender === '1' || curGender === '2') {
          let genderData = _(genderDatas).get(curGender)
          if (_(genderData).has(ageKey)) {
            let value = _(genderData).get(ageKey) + parseFloat(item.purchase_index)
            _.set(genderData, ageKey, value)
          }
        }
      } else {
        let genderData = _(genderDatas).get('all')
        if (_(genderData).has(ageKey)) {
          let value = _(genderData).get(ageKey) + parseFloat(item.purchase_index)
          _.set(genderData, ageKey, value)
        }
      }
    })
    console.log(genderDatas)
    let seriesDatas = {}
    _.forEach(genderDatas, function (genderData, key) {
      let seriesData = []
      _.forEach(genderData, function (value, key) {
        seriesData.push(parseFloat((value * 100).toFixed(2)))
      })
      _.set(seriesDatas, key, seriesData)
    })

    chartOption.xAxis.categories = agesCategories

    if (isGender) {
      _.forEach(seriesDatas, function (value, key) {
        if (key !== 'all') {
          let option = _.cloneDeep(chartOption)
          let subTitle = age + '歳刻み・'
          if (key === '1') {
            subTitle += '男性'
          } else {
            subTitle += '女性'
          }
          option.subtitle.text = subTitle
          option.series[0].data = value
          options.push(option)
        }
      })
    } else {
      chartOption.series[0].data = _(seriesDatas).get('all')
      chartOption.subtitle.text = age + '歳刻み'
      options.push(chartOption)
    }

    return options
  }

  buildIF0003ChartData (basicData, type, dataItems, yAxis) {
    let chartOption = _.cloneDeep(basicData)
    let categories = []
    let serieDataA = []
    let serieDataB = []
    _.forEach(dataItems, function (item) {
      categories.push(_(item).get('item_nm'))
      serieDataA.push(parseFloat((_(item).get('y_axis') * 100).toFixed(2)))
      serieDataB.push(parseFloat((_(item).get('repeat_rate') * 100).toFixed(2)))
    })

    chartOption.xAxis[0].categories = categories
    chartOption.yAxis[1].title.text = chartOptionUtil.getLegend('repeat_rate', 'リピート率')
    chartOption.yAxis[0].title.text = chartOptionUtil.getIF00003YTitle(yAxis)
    chartOption.series[1].name = chartOptionUtil.getLegend('repeat_rate', 'リピート率')
    chartOption.series[0].name = chartOptionUtil.getIF00003YTitle(yAxis)
    chartOption.series[0].data = serieDataA
    chartOption.series[1].data = serieDataB

    return chartOption
  }

  buildIF0004ChartData (basicData, type, dataItems, groupBy) {
    let chartOption = _.cloneDeep(basicData)

    const trialRate = chartOptionUtil.getLegend('trial_rate', 'トライアル率')
    const repeatRate = chartOptionUtil.getLegend('repeat_rate', 'リピート率')
    chartOption.xAxis.title.text = repeatRate
    chartOption.yAxis.title.text = trialRate
    chartOption.tooltip.pointFormat = chartOption.tooltip.pointFormat
      .replace('{repeat_rate}', repeatRate).replace('{trial_rate}', trialRate)

    let serieData = []
    let itemKey = 'item_nm'

    groupBy = _.sortBy(groupBy)
    _.forEachRight(groupBy, function (value) {
      if (_.startsWith(value, 'item_category_nm') ||
          _.startsWith(value, 'item_nm')) {
        itemKey = value
        return false
      }
    })
    _.forEach(dataItems, function (item) {
      let ageKey = ''
      let data = {}
      data.x = parseFloat((_(item).get('repeat_rate') * 100).toFixed(2))
      data.y = parseFloat((_(item).get('trial_rate') * 100).toFixed(2))
      let tooltipTitle = ''
      if (type !== 'all') {
        tooltipTitle = _(item).get(itemKey) + ' '
        ageKey = _.get(item, type)
        let gender = chartOptionUtil.getGenderDisplay(_(item).get('gender')) + ' '
        tooltipTitle = tooltipTitle + gender + ageKey
        data.name = tooltipTitle
      } else {
        tooltipTitle = _(item).get(itemKey) + ' '
        data.name = tooltipTitle
      }
      data.detail = tooltipTitle
      serieData.push(data)
    })
    chartOption.series[0].data = serieData
    return chartOption
  }

  buildIF0005ChartData (basicData, type, dataItems, groupBy) {
    let chartOption = _.cloneDeep(basicData)

    const purchaseQtyName = chartOptionUtil.getLegend('purchase_qty', '買上点数')
    chartOption.subtitle.text = purchaseQtyName
    chartOption.yAxis.title.text = purchaseQtyName

    let categories = []
    let seriesData = []

    _.forEach(dataItems, function (dataItem) {
      categories.push(_(dataItem).get('x_axis'))
    })
    if (groupBy.includes('day_of_week')) {
      categories = _.sortBy(_.uniq(categories), c => {
        c = _.replace(c, '月', '0')
        c = _.replace(c, '火', '1')
        c = _.replace(c, '水', '2')
        c = _.replace(c, '木', '3')
        c = _.replace(c, '金', '4')
        c = _.replace(c, '土', '5')
        c = _.replace(c, '日', '6')
        return c
      })
    } else {
      categories = _.uniq(categories)
    }

    let itemsList = _.chain(dataItems).groupBy(function (item) {
      return item.cd
    }).toArray().value()

    _.forEach(itemsList, function (itemList) {
      _.forEach(categories, function (category, index) {
        const c = _.filter(itemList, function (item) {
          return item.x_axis === category
        }).length
        if (c === 0) {
          // itemがcategoriesに存在しない場合、追加する
          itemList.splice(index, 0, { x_axis: category, cd: itemList[0].cd, nm: itemList[0].nm, y_axis: 0 })
        }
      })
      seriesData.push(itemList)
    })

    if (categories.length > 0) {
      chartOption.xAxis.categories = categories
      chartOption.series = []
      _.forEach(seriesData, function (serieData, index) {
        let series = {
          name: serieData[0].nm,
          data: _.map(serieData, 'y_axis')
        }
        chartOption.series.push(series)
      })
      return chartOption
    } else {
      return null
    }
  }

  buildIF0006ChartData (basicData, type, dataItems, conditionsGroupby) {
    let chartOption = _.cloneDeep(basicData)

    const simulPurchasersRateName = chartOptionUtil.getLegend('simul_purchasers_rate', '同時併買率')
    const purchasersLiftValueName = chartOptionUtil.getLegend('purchasers_lift_value', 'リフト値')
    chartOption.yAxis[0].title.text = purchasersLiftValueName
    chartOption.yAxis[1].title.text = simulPurchasersRateName
    chartOption.series[0].name = simulPurchasersRateName
    chartOption.series[1].name = purchasersLiftValueName

    let categories = []
    let serieDataA = []
    let serieDataB = []
    let groupBy = conditionsGroupby
    let itemKey = 'item_name'

    groupBy = _.sortBy(groupBy)
    _.forEachRight(groupBy, function (value) {
      if (_.startsWith(value, 'item_category_nm') ||
          _.startsWith(value, 'item_name')) {
        itemKey = value
        return false
      }
    })
    _.forEach(dataItems, function (item) {
      if (_(item).get(itemKey) === '未設定') {
        categories.push(_(item).get('item_name'))
      } else {
        categories.push(_(item).get(itemKey))
      }
      let purchasersRate = (_(item).get('simul_purchasers_rate') * 100).toFixed(2)
      let purchasersLiftValue = _(item).get('purchasers_lift_value').toFixed(2)
      serieDataA.push(parseFloat(purchasersRate))
      serieDataB.push(parseFloat(purchasersLiftValue))
    })

    if (categories.length > 0) {
      chartOption.xAxis.categories = categories
      chartOption.series[0].data = serieDataA
      chartOption.series[1].data = serieDataB
      return chartOption
    } else {
      return null
    }
  }

  buildIF0007ChartData (basicData, type, dataItems, conditionsTypeMode) {
    let chartOption = _.cloneDeep(basicData)

    const buyersOfTargetItemRateName = chartOptionUtil.getLegend('buyers_of_target_item_rate', '併買率')
    const liftValueName = chartOptionUtil.getLegend('lift_value', 'リフト値')
    const concurrentBuyersQtyName = chartOptionUtil.getLegend('concurrent_buyers_qty', '併買者数')
    chartOption.yAxis[0].title.text = concurrentBuyersQtyName
    chartOption.yAxis[1].title.text = buyersOfTargetItemRateName
    chartOption.series[0].name = buyersOfTargetItemRateName
    chartOption.series[1].name = concurrentBuyersQtyName
    if (conditionsTypeMode === 0) {
      chartOption.yAxis[0].title.text = liftValueName
      chartOption.series[1].name = liftValueName
    }

    let categories = []
    let serieDataA = []
    let serieDataB = []
    let title = chartOptionUtil.getIF00005Title(conditionsTypeMode)
    _.forEach(dataItems, function (item) {
      let itemNm = _(item).get('item_nm')
      let concurrentBuyersQty
      // 1619: 対象に名称がない場合は基準の名前を使う
      if (!itemNm) {
        itemNm = _(item).get('s_item_nm')
      }
      categories.push(itemNm)
      if (conditionsTypeMode === 0) {
        concurrentBuyersQty = (_(item).get('lift_value')).toFixed(2)
      } else {
        concurrentBuyersQty = _(item).get('concurrent_buyers_qty')
      }
      let purchasersRate = (_(item).get('buyers_of_target_item_rate') * 100).toFixed(2)
      serieDataA.push(parseFloat(purchasersRate))
      serieDataB.push(parseFloat(concurrentBuyersQty))
    })

    if (categories.length > 0) {
      chartOption.title.text = title
      chartOption.xAxis.categories = categories
      chartOption.series[0].data = serieDataA
      chartOption.series[1].data = serieDataB
      return chartOption
    } else {
      return null
    }
  }

  buildIF0010ChartData (basicData, type, dataItems, yAxis) {
    let chartOption = _.cloneDeep(basicData)
    let categories = []
    let serieData = []
    _.forEach(dataItems, function (item) {
      categories.push(_(item).get('x_axis'))
      if (_.includes(yAxis, '_rate_')) {
        serieData.push(parseFloat((_(item).get('y_axis') * 100).toFixed(2)))
      } else {
        serieData.push(_(item).get('y_axis'))
      }
    })

    if (type === 'item') {
      chartOption.subtitle.text = '商品別'
    } else if (type === 'store') {
      chartOption.subtitle.text = '店舗別'
    }
    chartOption.xAxis.categories = categories
    chartOption.series[0].name = chartOptionUtil.getIF00010YTitle(yAxis)
    chartOption.yAxis.title.text = chartOptionUtil.getIF00010YTitle(yAxis)
    chartOption.series[0].data = serieData
    // console.log(yAxis)
    if (_.includes(yAxis, '_rate_')) {
      chartOption.tooltip.pointFormatter = function () {
        let point = this
        return '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': <b>' + point.y.toFixed(2) + '%</b><br/>'
      }
    } else if (_.includes(yAxis, '_average')) {
      chartOption.tooltip.pointFormatter = function () {
        let point = this
        return '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': <b>' + point.y.toFixed(0) + '</b><br/>'
      }
    } else if (_.includes(yAxis, '_pi_')) {
      chartOption.tooltip.pointFormatter = function () {
        let point = this
        return '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': <b>' + point.y.toFixed(2) + '</b><br/>'
      }
    } else {
      chartOption.tooltip.pointFormatter = function () {
        let point = this
        return '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': <b>' + point.y + '</b><br/>'
      }
    }

    return chartOption
  }

  buildIF0011ChartData (basicData, dataItems, term, yAxis) {
    let chartOption = _.cloneDeep(basicData)
    let categories = []
    let serieData = []
    _.forEach(dataItems, function (item) {
      categories.push(_(item).get('item_nm'))
      serieData.push(parseFloat((_(item).get('y_axis') * 100).toFixed(2)))
    })

    chartOption.subtitle.text = '基準期間（' + term.search_term_base.from + ' 〜 ' + term.search_term_base.to + '）'
    chartOption.xAxis.categories = categories
    chartOption.series[0].name = chartOptionUtil.getIF00011YTitle(yAxis)
    chartOption.yAxis.title.text = chartOptionUtil.getIF00011YTitle(yAxis)
    chartOption.series[0].data = serieData

    return chartOption
  }
}
export default new ChartOptionService()
